(function () {
  var selectorGrid = '[data-product-grid]';
  var selectorPaginationWrapper = '[data-pagination]';
  var loadingClass = 'ff-infinite-loading';
  var doneClass = 'ff-infinite-done';

  function getNextUrl(paginationWrapper) {
    if (!paginationWrapper) return null;
    var nextLink = paginationWrapper.querySelector('a[rel="next"], a[aria-label="Next page"]');
    return nextLink ? nextLink.getAttribute('href') : null;
  }

  function dispatchEvent(grid, eventName, detail) {
    var event = new CustomEvent(eventName, {
      bubbles: true,
      detail: detail || {}
    });
    grid.dispatchEvent(event);
    window.dispatchEvent(event);
  }

  // Helper to get the parent infinite container
  function getInfiniteContainer(grid) {
    return grid.closest('[data-ff-infinite="true"]') || grid.closest('.shopify-section');
  }

  // Apply class to both grid and container
  function addClass(grid, className) {
    grid.classList.add(className);
    var container = getInfiniteContainer(grid);
    if (container) container.classList.add(className);
  }

  // Remove class from both grid and container
  function removeClass(grid, className) {
    grid.classList.remove(className);
    var container = getInfiniteContainer(grid);
    if (container) container.classList.remove(className);
  }

  // Check if grid has class
  function hasClass(grid, className) {
    return grid.classList.contains(className);
  }

  function appendNextPage(grid, paginationWrapper, url) {
    if (!url) return;

    addClass(grid, loadingClass);
    dispatchEvent(grid, 'ff:infinite:loading', { url: url });

    fetch(url, {
      method: 'GET',
      credentials: 'same-origin'
    })
      .then(function (res) { return res.text(); })
      .then(function (htmlText) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlText, 'text/html');

        var newGrid = doc.querySelector(selectorGrid);
        var newPaginationWrapper = doc.querySelector(selectorPaginationWrapper);

        // If no grid in the response, nothing more to load
        if (!newGrid) {
          removeClass(grid, loadingClass);
          addClass(grid, doneClass);
          if (paginationWrapper) {
            paginationWrapper.innerHTML = '';
          }
          dispatchEvent(grid, 'ff:infinite:done', { reason: 'no-grid' });
          return;
        }

        var newItems = Array.prototype.slice.call(
          newGrid.querySelectorAll('.grid__item')
        );

        // Count items before/after for event detail
        var countBefore = grid.querySelectorAll('.grid__item').length;

        newItems.forEach(function (item) {
          grid.appendChild(item);
        });

        var countAfter = grid.querySelectorAll('.grid__item').length;

        // Update or clear pagination HTML
        if (newPaginationWrapper) {
          paginationWrapper.innerHTML = newPaginationWrapper.innerHTML;

          // If new pagination has no real "next" link, mark as done
          var hasNext = newPaginationWrapper.querySelector('a[rel="next"], a[aria-label="Next page"]');
          if (!hasNext) {
            addClass(grid, doneClass);
            paginationWrapper.innerHTML = '';
            dispatchEvent(grid, 'ff:infinite:done', { reason: 'last-page' });
          }
        } else if (paginationWrapper) {
          paginationWrapper.innerHTML = '';
          addClass(grid, doneClass);
          dispatchEvent(grid, 'ff:infinite:done', { reason: 'no-pagination' });
        }

        // Re-run hover + card click logic on the newly extended grid
        if (window.FFInitHoverDwell) {
          window.FFInitHoverDwell(grid);
        }
        
        // FF: Initialize variant-aware hover images for newly loaded products
        if (window.FFInitCardHoverImages) {
          window.FFInitCardHoverImages(grid);
        }
        if (window.FFBindProductCardClicks) {
          window.FFBindProductCardClicks(grid);
        }

        // Re-initialize Judge.me star badges on dynamically injected cards
        if (window.jdgm && typeof jdgm.customizeBadges === 'function') {
          try { jdgm.customizeBadges(); } catch (e) { /* silent */ }
        }

        removeClass(grid, loadingClass);
        
        dispatchEvent(grid, 'ff:infinite:appended', {
          itemsAdded: countAfter - countBefore,
          totalItems: countAfter,
          url: url
        });
        
        // Legacy event for compatibility
        dispatchEvent(grid, 'ff:collection:appended', {
          itemsAdded: countAfter - countBefore,
          totalItems: countAfter
        });
      })
      .catch(function (err) {
        console.error('[FF Infinite] Fetch error:', err);
        removeClass(grid, loadingClass);
        dispatchEvent(grid, 'ff:infinite:error', { error: err });
      });
  }

  function findInfiniteGrids() {
    var grids = [];

    // Case 1: container has data-ff-infinite, UL has data-product-grid
    document.querySelectorAll('[data-ff-infinite="true"]').forEach(function (container) {
      var grid = container.querySelector(selectorGrid);
      if (grid) grids.push(grid);
    });

    // Case 2: UL itself has data-ff-infinite and data-product-grid
    document.querySelectorAll(selectorGrid + '[data-ff-infinite="true"]').forEach(function (grid) {
      if (grids.indexOf(grid) === -1) grids.push(grid);
    });

    return grids;
  }

  function checkInfinite() {
    var grids = findInfiniteGrids();
    if (!grids.length) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    grids.forEach(function (grid) {
      if (hasClass(grid, doneClass) || hasClass(grid, loadingClass)) return;

      var rect = grid.getBoundingClientRect();
      // Only load when user is within 400px of the bottom of this grid
      var nearBottom = rect.bottom - viewportHeight < 400;

      if (!nearBottom) return;

      var section = getInfiniteContainer(grid) || document;

      var paginationWrapper = section.querySelector(selectorPaginationWrapper);
      var nextUrl = getNextUrl(paginationWrapper);

      if (!nextUrl) {
        addClass(grid, doneClass);
        if (paginationWrapper) paginationWrapper.innerHTML = '';
        dispatchEvent(grid, 'ff:infinite:done', { reason: 'no-next-url' });
        return;
      }

      appendNextPage(grid, paginationWrapper, nextUrl);
    });
  }

  var onScrollThrottled = (function () {
    var timeout = null;
    return function () {
      if (timeout) return;
      timeout = setTimeout(function () {
        timeout = null;
        checkInfinite();
      }, 200);
    };
  })();

  function initInfiniteCollection() {
    // Initial check, in case the grid is short (will only load one extra page)
    checkInfinite();

    window.addEventListener('scroll', onScrollThrottled);
    window.addEventListener('resize', onScrollThrottled);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteCollection);
  } else {
    initInfiniteCollection();
  }
})();